import React, { Component } from 'react';
import './style.css';
class ICP extends Component {
  render() {
    return (
      <div className="icp_box">
        <a target="_blank" href="https://beian.miit.gov.cn">浙ICP备2021002240号-1</a>
      </div>
    );
  }
}

export default ICP;


// WEBPACK FOOTER //
// ./src/components/ICP/index.js